import React, { Component } from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Polyline,
  TrafficLayer,
} from "react-google-maps";
import URI from "urijs";
import { polylineDecode } from "../../utils/polylineEncodeDecode";
import moment from "moment";
import RequestManager from "../../singletons/RequestManager/RequestManager";

const MapComponent = withScriptjs(
  withGoogleMap((props) => {
    // if (props.userLocation.polyline) {
    //   console.log(polylineDecode(props.userLocation.polyline));
    // }

    return (
      <GoogleMap
        defaultZoom={13}
        defaultCenter={props.pickupPointLocation && props.pickupPointLocation}
      >
        {props.showUserMarker && (
          <Polyline
            path={
              props.userLocation.polyline &&
              polylineDecode(props.userLocation.polyline)
            }
          />
        )}
        <Marker
          position={props.pickupPointLocation && props.pickupPointLocation}
        />
        {
          // {props.showUserMarker && (
          //   <Marker
          //     position={props.userLocation}
          //     icon="https://maps.google.com/mapfiles/ms/icons/green-dot.png"
          //   />
          // )}
        }
        {props.deliveryLocations &&
          props.deliveryLocations.map((item) => {
            return (
              <Marker
                position={item.deliveryLocation}
                icon="https://maps.google.com/mapfiles/ms/icons/green-dot.png"
              />
            );
          })}

        <TrafficLayer autoUpdate />
      </GoogleMap>
    );
  })
);

export default class OrderMapView extends Component {
  constructor(props) {
    super(props);
    this.fetchInterval = null;

    this.state = {
      userLocation: null,
      deliveryLocations: null,
      tempdpHubs: null,
      usersIds: null,
    };
  }

  componentDidMount() {
    try {
      this.fetchInterval = setInterval(this.getDeliveryPersonLocation(), 5000);

      this.getDeliveryPersonLocation();
    } catch (e) {
      console.log("fetchUserLocation" + e);
    }
  }

  fetchUserLocation = async () => {
    if (this.props.trackingUrl != null) {
      let trackingUrl = URI(this.props.trackingUrl);
      let locationFetchUrl =
        "https://" + trackingUrl.hostname() + "/location/get";
      let locationResponse = await fetch(locationFetchUrl, {
        method: "GET",
        headers: {
          Token: this.props.trackingToken,
        },
      });

      let jsonResponse = await locationResponse.json();
      this.setState({
        userLocation: jsonResponse,
      });
    }
  };
  getDeliveryPersonLocation = async () => {
    let requestManager = new RequestManager();
    let params = {};
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getDeliveryPersonLocation",
      params
    );
    console.log("getDeliveryPersonLocation", JSON.stringify(response));
    if (response.error) {
      // alert('Something went wrong. Please try again later.')
    } else {
      let res = response;
      if (res.data.userProfile.user.store === null) {
      } else {
        let hubs = res.data.userProfile.user.store.hubs.edges;
        let usersIds = [],
          dpHubs = [];
        for (let i = 0; i < hubs.length; i++) {
          for (
            let j = 0;
            j < hubs[i].node.hubDeliveryPersonRef.edges.length;
            j++
          ) {
            if (hubs[i].node.hubDeliveryPersonRef.edges[j].node.isApprove) {
              let hub = {
                huds_id: hubs[i].node.id,
                hubs_name: hubs[i].node.name,
                hubDeliveryPersonRefId:
                  hubs[i].node.hubDeliveryPersonRef.edges[j].node.id,
                isApprove:
                  hubs[i].node.hubDeliveryPersonRef.edges[j].node.isApprove,
                isMerchantSercurity:
                  hubs[i].node.hubDeliveryPersonRef.edges[j].node
                    .isMerchantSercurity,
                status: hubs[i].node.hubDeliveryPersonRef.edges[j].node.status,
                dpId:
                  hubs[i].node.hubDeliveryPersonRef.edges[j].node.deliveryPerson
                    .id,
                userId:
                  hubs[i].node.hubDeliveryPersonRef.edges[j].node.deliveryPerson
                    .user,
                deliveryLocation: {
                  lat:
                    hubs[i].node.hubDeliveryPersonRef.edges[j].node
                      .deliveryPerson.latitude,
                  lng:
                    hubs[i].node.hubDeliveryPersonRef.edges[j].node
                      .deliveryPerson.longitude,
                },
              };
              dpHubs.push(hub);
              usersIds.push(
                hubs[i].node.hubDeliveryPersonRef.edges[j].node.deliveryPerson
                  .user
              );
            }
          }
        }

        var uniqueArrayUserids = [];

        // Loop through array values
        // eslint-disable-next-line
        for (var value of usersIds) {
          if (uniqueArrayUserids.indexOf(value) === -1) {
            uniqueArrayUserids.push(value);
          }
        }
        if (uniqueArrayUserids.length > 0) {
          this.setState({
            tempdpHubs: dpHubs,

            usersIds: usersIds,
          });

          this.getUsersByIDs(uniqueArrayUserids);
        }

        // let jsonResponse =
        //   res.data.userProfile.user.store.hubs.edges[0].node
        //     .hubDeliveryPersonRef;
        // let delivery = [];
        // console.log(JSON.stringify(jsonResponse));
        // for (let i = 0; i < jsonResponse.edges.length; i++) {
        //   if (jsonResponse.edges[i].node.isApprove) {
        //     let deliveryLocation = {
        //       deliveryLocation: {
        //         lat: jsonResponse.edges[i].node.deliveryPerson.latitude,
        //         lng: jsonResponse.edges[i].node.deliveryPerson.longitude,
        //       },
        //     };
        //     delivery.push(deliveryLocation);
        //   }
        // }
        // console.log("delivery", JSON.stringify(delivery));
        // this.setState({
        //   deliveryLocations: delivery,
        // });
      }
    }
  };

  getUsersByIDs = async (uniqueArrayUserids) => {
    let requestManager = new RequestManager();
    let params = {
      forUsers: uniqueArrayUserids,
    };
    console.log("params", JSON.stringify(params));
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getUsersByIDs",
      params
    );
    console.log("getUsersByIDs", JSON.stringify(response));
    if (response.error) {
      // alert('Something went wrong. Please try again later.')
    } else {
      let res = response;
      console.log("getUsersByIDs", JSON.stringify(res.data.users.edges));
      let hubs = this.state.tempdpHubs;
      let temphubs = [];
      console.log("");
      for (let i = 0; i < hubs.length; i++) {
        for (let j = 0; j < res.data.users.edges.length; j++) {
          if (
            hubs[i].dpId ===
            res.data.users.edges[j].node.deliveryPersons.edges[0].node.id
          ) {
            let hub = {
              huds_id: hubs[i].huds_id,
              hubs_name: hubs[i].hubs_name,
              hubDeliveryPersonRefId: hubs[i].hubDeliveryPersonRefId,
              isApprove: hubs[i].isApprove,
              isMerchantSercurity: hubs[i].isMerchantSercurity,
              status: hubs[i].status,
              dpId: hubs[i].dpId,
              userId: hubs[i].userId,
              deliveryLocation: hubs[i].deliveryLocation,
              dpPhone: res.data.users.edges[j].node.phone,
              dpFirstName: res.data.users.edges[j].node.userProfile.firstName,
              dpLastName: res.data.users.edges[j].node.userProfile.lastName,
            };

            temphubs.push(hub);
          }
        }
      }
      this.setState({ deliveryLocations: temphubs });
    }
  };

  fetchDeliveryLocation = async () => {
    if (this.props.trackingUrl != null) {
      let trackingUrl = URI(this.props.trackingUrl);
      let locationFetchUrl =
        "https://" + trackingUrl.hostname() + "/location/get";
      let locationResponse = await fetch(locationFetchUrl, {
        method: "GET",
        headers: {
          Token: this.props.trackingToken,
        },
      });

      let jsonResponse = await locationResponse.json();
      this.setState({
        userLocation: jsonResponse,
      });
    }
  };
  componentWillUnmount() {
    clearInterval(this.fetchInterval);
  }

  getDeliveryLocation = () => {
    if (this.state.userLocation !== null) {
      return {
        lat: 13.200329,
        lng: 79.168784,
        // polyline: this.state.userLocation.polyline,
      };
    } else {
      return {
        lat: 13.200329,
        lng: 79.168784,
        // polyline: this.state.userLocation.polyline,
      };
    }
  };

  getUserLocation = () => {
    if (this.state.userLocation !== null) {
      return {
        lat: this.state.userLocation.latitude,
        lng: this.state.userLocation.longitude,
        polyline: this.state.userLocation.polyline,
      };
    } else {
      return {};
    }
  };

  toTitleCase = (str) => {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  render() {
    return (
      <div style={{ backgroundColor: "white", width: "100%" }}>
        <div>
          <p
            style={{
              margin: 0,
              marginTop: 0,
              padding: 0,
              fontWeight: "bold",
              textAlign: "left",
            }}
          >
            {"Store dashboard:"}
          </p>
          {
            //   <h6>
            //     {"Dashboard last updated: " +
            //       moment(this.props.storeLastActive).fromNow()}
            //   </h6>
          }
        </div>
        {
          // <div>
          //   <p
          //     style={{
          //       margin: 0,
          //       marginTop: 0,
          //       padding: 0,
          //       fontWeight: "bold",
          //       textAlign: "left",
          //     }}
          //   >
          //     {"User location:"}
          //   </p>
          //   {this.state.userLocation && (
          //     <h6>
          //       {"User location updated: " +
          //         moment(this.state.userLocation.last_updated).fromNow()}
          //     </h6>
          //   )}
          // </div>
          // <div style={{ marginBottom: 20 }}>
          //   <p
          //     style={{
          //       margin: 0,
          //       marginTop: 0,
          //       padding: 0,
          //       fontWeight: "bold",
          //       textAlign: "left",
          //     }}
          //   >
          //     {"Order events:"}
          //   </p>
          //   {this.renderTrackedPoints()}
          // </div>
        }
        <MapComponent
          {...this.props}
          showUserMarker={this.state.userLocation !== null}
          deliveryLocations={this.state.deliveryLocations}
        />
      </div>
    );
  }

  renderTrackedPoints = () => {
    if (this.state.userLocation) {
      return (
        <div style={{ padding: 0, margin: 0 }}>
          {this.state.userLocation.tracked_points.map((trackedPoint) => {
            let type =
              trackedPoint.tracked_point_type ===
              "displacement_from_destination"
                ? "Distance"
                : "Time";
            type =
              this.toTitleCase(trackedPoint.client_defined_identifier) +
              " " +
              type;
            let value = "";

            if (
              trackedPoint.tracked_point_type ===
              "displacement_from_destination"
            ) {
              value = trackedPoint.value + " meters";
            } else {
              if (trackedPoint.execute_time) {
                value = moment(trackedPoint.execute_time).fromNow();
              } else {
                value = trackedPoint.value + " seconds from store";
              }
            }
            return (
              <div style={{ padding: 0, margin: 0 }}>{type + ": " + value}</div>
            );
          })}
        </div>
      );
    } else {
      return <div />;
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/OrderMapView/OrderMapView.js